import { SvgIcon, SxProps } from "@mui/material";
import IconSvg from "jsx:../../../Images/Icons/FontAwesome/solid/grid-2-plus.svg";

export function Grid2PlusIcon(props: SxProps) {
    return <SvgIcon component={IconSvg} inheritViewBox sx={props} />;
}
